import _ from 'lodash'
import InstanceFactory from '@/components/air8/utils/InstanceFactory'
import BaseCategory from './BaseCategory'
import config from './config'

const factory = new InstanceFactory<BaseCategory>(config, true)
export default factory
